import { useEffect } from 'react';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import BeforeAfter from './components/BeforeAfter';
import Services from './components/Services';
import { ReelsVideos } from './components/ReelsVideos';
import Testimonials from './components/Testimonials';
import Contact from './components/Contact';
import Footer from './components/Footer';

export default function HomePage() {
  useEffect(() => {
    const handleScroll = () => {
      const sections = ['hero', 'videos', 'antes-depois', 'tratamentos', 'depoimentos', 'contato'];
      const scrollPosition = window.scrollY + 100;

      sections.forEach(sectionId => {
        const section = document.getElementById(sectionId);
        if (section) {
          const sectionTop = section.offsetTop;
          const sectionHeight = section.offsetHeight;
          
          if (scrollPosition >= sectionTop && scrollPosition < sectionTop + sectionHeight) {
            const navLinks = document.querySelectorAll(`a[href="#${sectionId}"]`);
            navLinks.forEach(link => {
              document.querySelectorAll('.nav-link').forEach(l => l.classList.remove('active'));
              link.classList.add('active');
            });
          }
        }
      });
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Navbar activeSection="" />
      <Hero />
      <ReelsVideos />
      <BeforeAfter />
      <Services />
      <Testimonials />
      <Contact />
      <Footer />
    </div>
  );
}
